import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { ImportAndExportDataFilter } from '../model/importAndExportDataFilter';
import { SelectedVersion } from '../model/SelectedVersionList';

const apiServer = environment.apiServer;
const onImportField = $('#onImportField');

@Injectable()
export class LoadImportExportService {
  spinner: NgxSpinnerService;
  http: HttpClient;
  apiControl: string;
  downloadFileName: string;

  dtOptionsExportImportTable: DataTables.Settings = {};
  dataSetExportImportTable: any;
  importAndExportDataFilter: ImportAndExportDataFilter = new ImportAndExportDataFilter();
  selectedValueList: Array<SelectedVersion> = [];
  selectedValue: SelectedVersion = new SelectedVersion();



  constructor() { }


  ngOnInit() {

    this.spinner.show();

    this.dtOptionsExportImportTable = {
      pagingType: 'full_numbers',
      pageLength: 20,
      serverSide: true,
      processing: true,
      lengthChange: false,
      searching: false,
      autoWidth: true,
      paging: true,
      info: false,
      orderCellsTop: true,

      language: {
        emptyTable: 'Нет данных',
        info: 'Отображено с _START_ по _END_ из _TOTAL_ записей',
        infoEmpty: 'Отображено с 0 по 0 из 0 записей',
        infoFiltered: '(отфильтровано из _MAX_ записей)',
        infoPostFix: '',
        thousands: ',',
        lengthMenu: 'Показывать по _MENU_ записей',
        loadingRecords: 'Загрузка ...',
        processing: 'Обработка ...',
        search: 'Поиск:',
        zeroRecords: '',
        paginate: {
          first: 'Первая',
          last: 'Последняя',
          next: 'След.',
          previous: 'Пред.'
        },
        aria: {
          sortAscending: ': activate to sort column ascending',
          sortDescending: ': activate to sort column descending'
        }
      },
      ajax: (dataTablesParameters: any, callback) => {
        dataTablesParameters.search = this.importAndExportDataFilter.search;
        dataTablesParameters.version = this.selectedValue.version;

        this.http.post<any>(apiServer + this.apiControl, dataTablesParameters, {})
          .subscribe(resp => {
            this.dataSetExportImportTable = resp.data;
            this.spinner.hide();
            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: []
            });
          });
      }
    };

    this.http.get<Array<SelectedVersion>>(apiServer + "/versioninfo" + "/Region")
    .subscribe(resp => {
      this.selectedValueList[0] = { author:"", version:"" }
      for (let index = 0; index < resp.length; index++) {
        this.selectedValueList[index + 1] = resp[index];
      }
    });

  }

}




// WEBPACK FOOTER //
// ./src/app/modules/user/service/load-import-export.service.ts